<div class="bcg">

    <div class="row">
        <div class="col-lg-6 col-sm-6 col-md-6">
            <a [routerLink]="['/doqfy/dashboard']" class="btn-link title_link_align title_link_0">Dashboard >> </a>
            <a [routerLink]="['/doqfy/viewAllOrders']" class="btn-link title_link_0">Order Details</a>
        </div>
    </div>

    <div class="row" style="margin: auto;">       
    
        <div class="col-lg-12 col-sm-12 col-md-12">
                <div class="row">
                   <app-order-details-dashboard></app-order-details-dashboard>
                </div>
               <div class="row mt-2">
                <app-revent-activity-list></app-revent-activity-list>
               </div>
        </div>
    </div>
</div>
